import { useMutation } from '@tanstack/react-query'
import { previewDocumentSignatureTemplate } from 'api/company/previewDocumentSignatureTemplate'

export function usePreviewDocumentSignatureTemplateMutation(companyId: number) {
  return useMutation({
    mutationFn: ({
      fileId,
      data,
    }: {
      fileId: number
      data: Record<string, string | boolean>
    }) => previewDocumentSignatureTemplate(companyId, fileId, { data }),
  })
}
